function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.444 1.222)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paket-data_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: -265.043,
  y1: 409.202,
  x2: -264.045,
  y2: 409.202,
  gradientTransform: "matrix(12.2222 0 0 -19.5556 3239.646 8011.943)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#256db5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#004a93"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.9 0h8.9c.9 0 1.7.7 1.7 1.7v16.2c0 .9-.7 1.7-1.7 1.7H1.9c-.9 0-1.7-.7-1.7-1.7V1.7C.2.7 1 0 1.9 0z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#paket-data_svg__a)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paket-data_svg__b",
  gradientUnits: "userSpaceOnUse",
  x1: -258.653,
  y1: 405.632,
  x2: -258.789,
  y2: 407.527,
  gradientTransform: "matrix(9.7778 0 0 -17.1111 2535.782 6960.423)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5d9cec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0e65d7"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.3 1.7c0 .4.3.8.8.8h4.6c.4 0 .8-.3.8-.8v-.5h.9c.5 0 .9.4.9.9v15.3c0 .5-.4.9-.9.9h-8c-.5 0-.9-.4-.9-.9V2.2c0-.5.4-.9.9-.9h.9v.4z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#paket-data_svg__b)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.089 5.042)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paket-data_svg__c",
  gradientUnits: "userSpaceOnUse",
  x1: -264.345,
  y1: 381.632,
  x2: -264.345,
  y2: 380.638,
  gradientTransform: "matrix(9.3194 0 0 -9.3194 2468.206 3556.597)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#38a7f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#004a93"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.6 0h6.2c.9 0 1.6.7 1.6 1.5v6.2c0 .9-.7 1.6-1.6 1.6H1.6C.7 9.3 0 8.6 0 7.8V1.5C0 .7.7 0 1.6 0z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#paket-data_svg__c)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paket-data_svg__d",
  gradientUnits: "userSpaceOnUse",
  x1: -250.028,
  y1: 331.944,
  x2: -249.037,
  y2: 331.944,
  gradientTransform: "matrix(6.2857 0 0 -4.4 1573.314 1464.99)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d2edfc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#38a7f2"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.9 3.4c-1.7-1.6-4.4-1.6-6.2 0-.1.1-.1.2 0 .2l.4.4c.1.1.2.1.2 0 1.4-1.3 3.6-1.3 5.1 0 .1.1.2.1.2 0l.3-.3c.1-.1.1-.2 0-.3zm-3.1 2c-.3 0-.6.3-.6.6s.3.6.6.6.6-.3.6-.6-.2-.6-.6-.6zm2-.8c-1.1-1-2.9-1-4 0-.1.1-.1.2 0 .2l.3.3c.1.1.2.1.2 0 .8-.7 2.1-.7 2.9 0 .1.1.2.1.2 0l.3-.3c.2-.1.2-.2.1-.2z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "url(#paket-data_svg__d)"
})));

function SvgPaketData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _ref);
}

export default SvgPaketData;